import { ToastType } from 'modules/application/misc/ToastService';
import { CONFIGURATIONS_KEY_ITEM_VALUE_COPIED } from '../../ConfigurationsSegmentEvents';
export class CreatedKeyModalController {
    static $inject = ['BlipToastService', 'SegmentService', '$translate', 'clipboard', 'close', 'shortName', 'key', 'sdkkey'];
    constructor(BlipToastService, SegmentService, $translate, clipboard, close, shortName, key, sdkkey) {
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.clipboard = clipboard;
        this.close = close;
        this.shortName = shortName;
        this.key = key;
        this.sdkkey = sdkkey;
        this.closeModal = async () => {
            this.close(true);
        };
        this.httpkey = `Key ${btoa(`${this.shortName}:${atob(this.sdkkey)}`)}`;
    }
    async copyKeyToClipboard(kind, value) {
        this.clipboard.copyText(value);
        this.SegmentService.createApplicationTrack({
            trackEvent: CONFIGURATIONS_KEY_ITEM_VALUE_COPIED,
            payload: {
                kind,
                keyId: this.key.id,
            },
        });
        this.BlipToastService.show(ToastType.Success, {
            msg: await this.$translate('utils.successMsg.30'),
        });
    }
}
CreatedKeyModalController.$inject = ['BlipToastService', 'SegmentService', '$translate', 'clipboard', 'close', 'shortName', 'key', 'sdkkey'];
